// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","content":"App_content__wwONY"};